module.exports = __webpack_public_path__ + "img/gmail.a189ad2b.png";